import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { ButtonGroup } from '@atlaskit/button';
import type { issuePagination_issueNavigator$key as IssuePaginationKey } from '@atlassian/jira-relay/src/__generated__/issuePagination_issueNavigator.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import { useIssuesCount } from '../../../../../controllers/selected-issue/hooks.tsx';
import IssuePaginationNextButton from './next-button/index.tsx';
import IssuePaginationPreviousButton from './previous-button/index.tsx';

export type Props = {
	/**
	 * Relay fragment for issue search data.
	 */
	issueResults: IssuePaginationKey | null;
};

const IssuePagination = ({ issueResults }: Props) => {
	let issuesCount = 0;
	if (fg('refactor_nin_to_jira_view_schema')) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		issuesCount = useIssuesCount();
	}

	const issueResultsData = useFragment<IssuePaginationKey>(
		graphql`
			fragment issuePagination_issueNavigator on JiraIssueConnection {
				totalIssueSearchResultCount @required(action: THROW)
				isCappingIssueSearchResult
			}
		`,
		issueResults,
	);

	const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
	const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;

	return (
		<>
			<ButtonGroup>
				<IssuePaginationPreviousButton />
				<IssuePaginationNextButton
					totalResultCount={totalIssueSearchResultCount}
					isCappingIssueSearchResult={isCappingIssueSearchResult}
				/>
			</ButtonGroup>
		</>
	);
};

export default IssuePagination;
